import React from 'react';
import { admin_themes_path } from 'modules/routes';
import LayoutDropdown, { LayoutValue } from '@/components/admin/SectionEditor/LayoutDropdown';
import ThemeDropdown from '@/components/admin/SectionEditor/ThemeDropdown';

interface SharedControlsProps {
  currentThemeId: number;
  layout?: LayoutValue;
  onChangeLayout: (value: string) => any;
  onChangeTheme: React.Dispatch<React.SetStateAction<number>>;
}

// The reference-material-wide dropdowns. ReadingEditor portals this above the reading tabs, so it
// stays inside the editor's React tree (Layout needs the Froala instance, Theme drives the editor's
// live theme class) while rendering where the design puts it.
const SharedControls = ({
  currentThemeId,
  layout,
  onChangeLayout,
  onChangeTheme,
}: SharedControlsProps) => (
  <>
    {layout && (
      <LayoutDropdown
        initialValue={layout}
        name="reference_material[column_layout]"
        onChange={onChangeLayout}
      />
    )}
    <div className="tw-flex tw-justify-between">
      <ThemeDropdown
        currentThemeId={currentThemeId}
        name="reference_material[theme_id]"
        onChange={onChangeTheme}
      />
      <div className="tw-flex tw-items-end">
        <a
          className="btn btn--sm btn--outline-purple"
          href={admin_themes_path({ theme_id: currentThemeId })}
          rel="noopener noreferrer"
          target="_blank"
        >
          <i className="fa fa-pencil-square-o tw-pr-[2px]" />
          Edit CSS
        </a>
      </div>
    </div>
  </>
);

export default SharedControls;
